import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const usersOnboardingService = {
  getStudyStatus,
  getProjectStatus,
  getCountries,
  getStates,
  getCities,
  updateUserByID,
  getUsersUpdateHistoryData,
  getUserActivities,
  getTotalClient,
  getTotalClientGraph,
  getDashboardComponentData,
  updateDashboardComponent,
};


async function getUserActivities() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserActivities`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyStatus() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyStatus`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectStatus() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectStatus`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function updateUserByID(userData, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}user/updateUsersClients`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  let getResponse = await handleResponse(data);
  if (getResponse === true) {
    history(`/adminRole`);
  }
}

async function getUsersUpdateHistoryData(userId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUsersUpdateHistoryData/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}


async function getCountries() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCountries`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStates(CountryID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStates/${CountryID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getCities(StateID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCities/${StateID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getTotalClient() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalClient`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getTotalClientGraph() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalClientGraph`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Dashboard Standard Graph
async function getDashboardComponentData() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDashboardComponentData`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Study Dashboard Component
async function updateDashboardComponent(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateDashboardComponent`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
